import { render, staticRenderFns } from "./ChannelResults.vue?vue&type=template&id=9902cd42&scoped=true"
import script from "./ChannelResults.vue?vue&type=script&lang=js"
export * from "./ChannelResults.vue?vue&type=script&lang=js"
import style0 from "./ChannelResults.vue?vue&type=style&index=0&id=9902cd42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9902cd42",
  null
  
)

export default component.exports